import { AppState } from "features/state";
import { createSelector } from "reselect";

const getPublishDisabled = (state: AppState) => state.locations.publish.publishingDisabled;

export const getIsPublishDisabled = createSelector(getPublishDisabled, (result) => result || false);
